// Remembers a list page's last search (filters, page, filter box selections) for this browser tab,
// so coming back from a details page or after an action shows the same filtered list again.
const storageKey = (key) => `listState:${key}`;

export const getListState = (key) => {
  try {
    return JSON.parse(sessionStorage.getItem(storageKey(key))) || null;
  } catch (error) {
    return null;
  }
};

// Merges into what is already saved for the list
export const saveListState = (key, state) => {
  try {
    sessionStorage.setItem(storageKey(key), JSON.stringify({ ...(getListState(key) || {}), ...state }));
  } catch (error) {
    // storage unavailable (private mode / blocked): list just works without remembering
  }
};

export const clearListState = (key) => {
  try {
    sessionStorage.removeItem(storageKey(key));
  } catch (error) {
    // ignore
  }
};

// Filters object with every key set to undefined, used by Reset to really clear the merged filters
export const clearedFilters = (filters) =>
  Object.keys(filters || {}).reduce((acc, key) => ({ ...acc, [key]: undefined }), {});
